import {
    EditField,
    InputFields,
    InputFieldsReturn,
    InputProcData,
    MessageProcData,
    ProcBaseData,
    ProcData
} from 'priority-web-sdk';
import {startProcedure} from '../services/websdk';
import {showErrorMessage} from '../../../_shared/Messages/actions/MessageActions';
import texts from '../../ReportGenerator/texts';
import {showSuccessToast} from '../../../components/Toast/actions/ToastActions';

export type ProcType = {
    procRes: ProcData;
    updateFunc: (inputFields: EditField[], repExec: number, menuName: string) => InputFieldsReturn;
    repExec?: number;
    menuName?: string;
    successfulText?: string;
};

export const runProcedure = async (
    procName: string,
    updateInputFields,
    repExec: number,
    menuName: string,
    successfulText?: string
) => {
    const procRes: ProcData = await startProcedure(procName, 'P');
    return processProcStepResult({
        procRes,
        updateFunc: updateInputFields,
        repExec,
        menuName,
        successfulText
    });
};

const processProcStepResult = async ({
    procRes,
    updateFunc,
    repExec,
    menuName,
    successfulText
}: ProcType) => {
    const proc = procRes.proc;
    switch (procRes.type) {
        case 'inputFields':
            const input: InputFields = (procRes as InputProcData).input as InputFields;
            const inputFields: EditField[] = input.EditFields;
            const updatedInputFields: InputFieldsReturn = updateFunc(
                inputFields,
                repExec,
                menuName
            );
            const res = await proc.inputFields(1, updatedInputFields);
            return processProcStepResult({procRes: res, updateFunc, successfulText});
        case 'message':
            const msgRes = procRes as ProcBaseData & MessageProcData;
            if (msgRes.messagetype === 'information') {
                showSuccessToast(successfulText);
                return true;
            } else if (msgRes.messagetype === 'error') {
                const processProcContinue = async () => {
                    const res = await proc.continueProc();
                    processProcStepResult({procRes: res, updateFunc});
                };
                showErrorMessage({
                    content: msgRes.message,
                    onConfirm: processProcContinue,
                    confirmButtonText: texts.ok,
                    defaultButton: 0
                });
                return false;
            }
            return false;

        default:
            return false;
    }
};
